import { Subject, of, race } from 'rxjs';
import { delay, filter, take, timeInterval } from 'rxjs/operators';
import { defineComponent } from 'vue';

declare const config
const DEFAULT_TIMEOUT: number = config.touchable_component.defaultTimeout

export const Touchable = defineComponent({
    props: {
        timeout: {
            type: Number,
            default: DEFAULT_TIMEOUT,
        }
    },
    template: require('./touchable.html'),
    data() {
        return {
            touched: false,
            touch$: new Subject(),
        }
    },
    methods: {
        onTouchStart(event: TouchEvent) {
            this.touched = true
            this.touch$.next(event)

            // if the user is clicking since timeout seconds
            const timer$ = of({ interval: this.timeout + 1, value: {type: 'touchend'} }).pipe(
                delay(this.timeout + 1)
            )

            // if the user realease his finger
            const touchend$ = this.touch$.pipe(
                timeInterval(),
                filter(({interval, value}) => {
                    if ((value as TouchEvent).type === 'touchend') {
                        return true
                    }
                    return false
                }),
                take(1)
            )

            race(
                timer$,
                touchend$,
            ).subscribe(({interval, value}) => {
                if (interval > this.timeout) {
                    this.touched = false
                    this.$emit('touchtimed')
                }
            })
        },

        onTouchEnd(event: TouchEvent) {
            this.touched = false;
            this.touch$.next(event);
        },

        onContextMenu(event: TouchEvent) {
            event.preventDefault()
        },

        onTouchMove(event: TouchEvent) {
            this.touch$.next(event);
        },
    },
})
